import React from "react";
import { NavLink } from "react-router-dom";

export const NavBarBrand = () => {
  return (
    <div className="nav-bar__brand">
      <NavLink to="/" className="nav-bar__link">
        <img
          className="nav-bar__logo"
          src="https://imagedelivery.net/cQwdhF-H4tUVK8IxRhv2kQ/a2a6657f-07be-42ff-623b-2f3543989300/public"
          alt="Fjell Hosting logo"
        />
        <h2 className="nav-bar__title">Fjell Digital</h2>
      </NavLink>
    </div>
  );
};
